// Path parameter의 key name
export enum PathParamKeyEnum {
  IMAGE_ID = ':imageIdPathParam',
  COLLECTION_ID = ':collectionIdPathParam',
  USER_ID = ':userIdPathParam'
}

// url Query string의 key name
export enum QueryParamKeyEnum {
  IS_IMAGE_MODAL_VISIBLE = 'isImageModalVisible',
  IMAGE_ID = 'imageId',
  SEQUENCE_ID = 'sequenceId',
  S3_URL = 's3Url',
  FROM_PAGE = 'fromPage',
  PAGE = 'page',
  THEME = 'theme',
  INITIAL_IMAGE_ID = 'initialImageId'
}

// 이미지 업로드/정보 수정 페이지 상단의 브레드크럼 분기를 위한 enum
// e.g. /admin/image-upload?fromPage=STANDARD
export enum FromPageQueryParamValueEnum {
  STANDARD = 'standard',
  ADULTS_ONLY = 'adultsOnly',
  OPEN_ISSUE_REPORT_LIST = 'openIssueReportList',
  RESOLVED_ISSUE_REPORT_LIST = 'resolvedIssueReportList',
  DELETED_IMAGE_LIST = 'deletedImageList'
}
